import { boards } from "./boards/boards";
import { calendars } from "./calendars/calendars";
import { config } from "./config/config";
import { calendarSets } from "./calendarSets/calendarSets";
import { tenantHolidays } from "./tenantHolidays/tenantHolidays";

export const calendarService = {
  boards,
  calendars,
  calendarSets,
  config,
  tenantHolidays,
};
